// extracted by mini-css-extract-plugin
export var bubble = "_2z-0";
export var container = "_2z-f";
export var contrastBorder = "_2z-g";
export var greyOut = "_2z-2";
export var initialsColor0 = "_2z-3";
export var initialsColor1 = "_2z-4";
export var initialsColor10 = "_2z-d";
export var initialsColor11 = "_2z-e";
export var initialsColor2 = "_2z-5";
export var initialsColor3 = "_2z-6";
export var initialsColor4 = "_2z-7";
export var initialsColor5 = "_2z-8";
export var initialsColor6 = "_2z-9";
export var initialsColor7 = "_2z-a";
export var initialsColor8 = "_2z-b";
export var initialsColor9 = "_2z-c";
export var initialsWrapper = "_2z-1";
export var large = "_2z-l";
export var medium = "_2z-k";
export var mediumSmall = "_2z-j";
export var mediumSmallMedium = "_2z-o";
export var micro = "_2z-h";
export var small = "_2z-i";
export var tiny = "_2z-n";
export var xTiny = "_2z-m";